<template>
  <div class="list" ref="listRoot">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">系统</Breadcrumb-item>
        <Breadcrumb-item>自动排课配置管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/adminConfig/getTConfigList"
          :params="queryParam" :onLoading="onLoading" :onSelection="onSelection"></List>
    <Modal title="学导id" v-model="showValueModal" :width="modalWidth">
      <div style="word-break: break-all; white-space: pre-wrap; max-height: 360px; overflow: auto;">{{ fullValue }}</div>
      <div slot="footer">
        <Button type="primary" @click="showValueModal = false">关闭</Button>
      </div>
    </Modal>
    <Modal title="编辑配置信息" class="modal" v-model="showEditTconfig" :width="modalWidth">
      <Form ref="form" class="form" :label-width="80" :model="formData">
        <Form-item label="ids：" prop="configValue">
          <Input v-model="formData.configValue"></Input>
        </Form-item>
        <Form-item label="状态：" prop="status">
          <Select v-model.number="formData.status" transfer clearable>
            <Option v-for="item in $constant.enabledStatus" :value="item.code" :key="item.code" :label="item.text"></Option>
          </Select>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="onClose">取消</Button>
        <Button type="primary" size="large" :loading="loading" @click="onSubmit">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  const COL_STATUS = 88
  const COL_ACTION = 100
  const COL_KEY_MIN = 140
  const COL_TITLE_MIN = 160
  const COL_VALUE_MIN = 180

  function fitWidths (containerWidth) {
    let width = parseInt(containerWidth, 10) || 0
    let fixed = COL_STATUS + COL_ACTION
    let floors = COL_KEY_MIN + COL_TITLE_MIN + COL_VALUE_MIN
    let usable = width - 2
    if (usable <= fixed + floors) {
      return {
        key: COL_KEY_MIN,
        title: COL_TITLE_MIN,
        value: COL_VALUE_MIN
      }
    }
    let extra = usable - fixed - floors
    let unit = Math.floor(extra / 5)
    let rest = extra - unit * 5
    return {
      key: COL_KEY_MIN + unit * 2,
      title: COL_TITLE_MIN + unit * 2,
      value: COL_VALUE_MIN + unit + rest
    }
  }

  function ellipsisText (h, text) {
    let value = text || ''
    return h('span', {
      attrs: {title: value},
      style: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, value)
  }

  function buildColumns (widths, self, $constant) {
    return [
      {
        title: 'Key',
        key: 'configKey',
        align: 'center',
        width: widths.key,
        ellipsis: true,
        render: (h, params) => ellipsisText(h, params.row.configKey)
      },
      {
        title: '配置标题',
        key: 'title',
        align: 'center',
        width: widths.title,
        ellipsis: true,
        render: (h, params) => ellipsisText(h, params.row.title)
      },
      {
        title: '学导id',
        key: 'configValue',
        align: 'center',
        width: widths.value,
        ellipsis: true,
        render: (h, params) => {
          let value = params.row.configValue || ''
          if (value.length <= 24) {
            return h('span', value)
          }
          return h('a', {
            style: {whiteSpace: 'nowrap'},
            on: {click: () => self.showFullValue(value)}
          }, value.slice(0, 24) + '...')
        }
      },
      {
        title: '状态',
        align: 'center',
        width: COL_STATUS,
        render: (h, params) => {
          let status = params.row.status
          let color = status === 0 ? 'red' : ''
          let statusEnum = $constant.getEnum($constant.enabledStatus, status)
          return h('div', {style: {color: color}}, statusEnum && statusEnum.text)
        }
      },
      {
        title: '操作',
        align: 'center',
        width: COL_ACTION,
        render: (h, params) => {
          return h('el-button', {
            props: {type: 'primary', size: 'mini'},
            on: {click: () => self.onEdit(params.row)}
          }, '编辑')
        }
      }
    ]
  }

  export default {
    data () {
      let $constant = this.$constant
      let self = this
      let screen = window.innerWidth || 1280
      return {
        onLoading: false,
        queryParam: {},
        reload: 0,
        showEditTconfig: false,
        showValueModal: false,
        fullValue: '',
        modalWidth: Math.max(320, Math.min(600, screen - 48)),
        appliedKey: 0,
        appliedTitle: 0,
        appliedValue: 0,
        resizeTimer: null,
        formData: {
          id: null,
          configValue: '',
          status: null
        },
        title: buildColumns(fitWidths(screen - 306), self, $constant)
      }
    },
    mounted () {
      this.applyLayout()
      window.addEventListener('resize', this.onResize)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
    },
    methods: {
      onResize () {
        if (this.resizeTimer) {
          clearTimeout(this.resizeTimer)
        }
        this.resizeTimer = setTimeout(() => {
          this.applyLayout()
        }, 80)
      },
      applyLayout () {
        let screen = window.innerWidth || 1280
        this.modalWidth = Math.max(320, Math.min(600, screen - 48))
        let container = screen - 306
        if (this.$refs.listRoot && this.$refs.listRoot.clientWidth) {
          container = this.$refs.listRoot.clientWidth
        }
        let widths = fitWidths(container)
        if (widths.key === this.appliedKey && widths.title === this.appliedTitle && widths.value === this.appliedValue) {
          return
        }
        this.appliedKey = widths.key
        this.appliedTitle = widths.title
        this.appliedValue = widths.value
        this.title = buildColumns(widths, this, this.$constant)
      },
      search () {
        this.reload = new Date().getTime()
      },
      showFullValue (value) {
        this.fullValue = value
        this.showValueModal = true
      },
      onEdit (row) {
        this.formData = {}
        this.formData.id = row.id
        this.formData.configValue = row.configValue
        this.formData.status = row.status
        this.showEditTconfig = true
      },
      onSelection (selection) {
        this.selection = selection
      },
      onSubmit () {
        let self = this
        this.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            return
          }
          self.$http.post('/adminConfig/editTConfig', self.formData).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('保存成功!')
              self.showEditTconfig = false
              self.formData = {}
              self.search()
            }
          })
        })
      },
      onClose () {
        this.showEditTconfig = false
        this.formData = {}
        this.search()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AdminTConfigList.vue?7d0a4313